module.exports = __webpack_public_path__ + "img/ecoshopbanner.f303b20c.png";